module.exports = __webpack_public_path__ + "static/media/jayco5.2877ba8c.JPG";